import { Injectable, inject } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';

import { CurrencyPipe } from '../../../../../base/pipes/currency.pipe';
import { selectIsLinearBetslip } from '../../../../../base/store/selectors';

@Injectable({
    providedIn: 'root',
})
export class LinearFocusPlaceholderService {
    private readonly currencyPipe = inject(CurrencyPipe);
    private readonly isEpcot = inject(EpcotConfig).isEnabled;
    private readonly isLinear = inject(Store).selectSignal(selectIsLinearBetslip);

    get focusPlaceholder(): string | undefined {
        if (!this.isLinear() || !this.isEpcot) {
            return undefined;
        }

        return this.currencyPipe.transform(0, true, 2, true);
    }
}
